var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative pb-1"},[_c('ColorForm',{attrs:{"title":'Create Color',"action":"Save"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }